import { wrapAround } from "../utils"

export const webRadiansToAzimuth = (radians: number): number => {
  const degrees = (radians * 180) / Math.PI
  const wrapped = wrapAround(degrees + 90, [0, 360])

  return Math.round(wrapped)
}
